'use es6';

import { groupBy } from 'underscore';
import { EDITOR_ERRORS_CLEAR, EDITOR_ERRORS_CLEAR_ALL, EDITOR_ERRORS_SET, EDITOR_ERRORS_ADD, EDITOR_ERRORS_HUBL_SET, EDITOR_ERRORS_HUBL_CLEAR, EDITOR_ERRORS_HUBL_CLEAR_ALL, EDITOR_ERRORS_CSS_SET, EDITOR_ERRORS_CSS_CLEAR, EDITOR_ERRORS_CSS_CLEAR_ALL, EDITOR_ERRORS_JS_SET, EDITOR_ERRORS_JS_CLEAR, EDITOR_ERRORS_JS_CLEAR_ALL } from 'DesignData/actions/ActionTypes';
import { flash } from 'DesignData/actions/Flash';
import { OPEN_STATUS_BAR_DRAWER } from 'DesignData/enums/FlashKeys';
export function addErrors(assetId, __errors) {
  const errors = Array.isArray(__errors) ? __errors : [__errors];
  const groupedErrors = groupBy(errors, 'type');
  return {
    type: EDITOR_ERRORS_ADD,
    assetId,
    groupedErrors
  };
}
export function setErrors(assetId, __errors) {
  const errors = Array.isArray(__errors) ? __errors : [__errors];
  const groupedErrors = groupBy(errors, 'type');
  return {
    type: EDITOR_ERRORS_SET,
    assetId,
    groupedErrors
  };
}
export function clearErrors(assetId) {
  return {
    type: EDITOR_ERRORS_CLEAR,
    assetId
  };
}
export function clearAllErrors() {
  return {
    type: EDITOR_ERRORS_CLEAR_ALL
  };
}
export function openDrawer() {
  return flash(OPEN_STATUS_BAR_DRAWER, true);
}
/**
 * Set errors from HubL validation
 * @param {Number}                  assetId
 * @param {String|Number}           sessionId
 * @param {Array.<CodeEditorError>} errors
 */

export function setHublErrors(assetId, sessionId, errors) {
  return {
    type: EDITOR_ERRORS_HUBL_SET,
    assetId,
    sessionId,
    errors
  };
}
/**
 * Remove errors from HubL validation for a specific asset.
 * @param {Number}        assetId
 * @param {String|Number} sessionId
 */

export function clearHublErrors(assetId, sessionId) {
  return {
    type: EDITOR_ERRORS_HUBL_CLEAR,
    assetId,
    sessionId
  };
}
/**
 * Clears all HubL validation errors.
 */

export function clearAllHublErrors() {
  return {
    type: EDITOR_ERRORS_HUBL_CLEAR_ALL
  };
}
/**
 * Set errors from CSS linting
 * @param {Number}                  assetId
 * @param {String|Number}           sessionId
 * @param {Array.<CodeEditorError>} errors
 */

export function setCssErrors(assetId, sessionId, errors) {
  return {
    type: EDITOR_ERRORS_CSS_SET,
    assetId,
    sessionId,
    errors
  };
}
/**
 * Remove errors from CSS linting for a specific asset
 * @param {Number}        assetId
 * @param {String|Number} sessionId
 */

export function clearCssErrors(assetId, sessionId) {
  return {
    type: EDITOR_ERRORS_CSS_CLEAR,
    assetId,
    sessionId
  };
}
/**
 * Clears all CSS linting errors.
 */

export function clearAllCssErrors() {
  return {
    type: EDITOR_ERRORS_CSS_CLEAR_ALL
  };
}
/**
 * Set errors from JS linting
 * @param {Number}                  assetId
 * @param {String|Number}           sessionId
 * @param {Array.<CodeEditorError>} errors
 */

export function setJsErrors(assetId, sessionId, errors) {
  return {
    type: EDITOR_ERRORS_JS_SET,
    assetId,
    sessionId,
    errors
  };
}
/**
 * Remove errors from JS linting for a specific asset.
 * @param {Number}        assetId
 * @param {String|Number} sessionId
 */

export function clearJsErrors(assetId, sessionId) {
  return {
    type: EDITOR_ERRORS_JS_CLEAR,
    assetId,
    sessionId
  };
}
/**
 * Clears all JS linting errors.
 */

export function clearAllJsErrors() {
  return {
    type: EDITOR_ERRORS_JS_CLEAR_ALL
  };
}